/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { NgModule } from "@angular/core";
import { RouterModule, Routes, Router } from "@angular/router";
import { ForgotPasswordComponent } from "./features/auth-feature/forgot-password/forgot-password.component";
import { SigninComponent } from "./features/auth-feature/signin/signin.component";
import { SignupComponent } from "./features/auth-feature/signup/signup.component";
import { VerificationComponent } from "./features/auth-feature/verification/verification.component";
import { UserProfileComponent } from "./features/user/user-profile/user-profile.component";
import { CheckUrlComponent } from "./shared/check-url/check-url.component";
import { MapsComponent } from "./shared/commoncomponents/maps/maps.component";
import { AppCustomPreloader } from "./custom/custom-preloader";
import { CanDeactivateGaurdService } from "./shared/can-deactivate-gaurd.service";
// import { SlotDetailedViewComponent } from './features/appointments/slot-detailed-view/slot-detailed-view.component';
const routes: Routes = [
  {
    path: "appointments",
    loadChildren: () =>
      import("./features/appointments/appointments.module").then(
        (m) => m.AppointmentsModule
      ),
  },
  {
    path: "stores",
    loadChildren: () =>
      import("./features/all-stores/all-stores.module").then(
        (m) => m.AllStoresModule
      ),
  },
  {
    path: "my-company",
    loadChildren: () =>
      import("./features/my-company/my-company.module").then(
        (m) => m.MyCompanyModule
      ),
  },
  {
    path: "media-templates",
    loadChildren: () =>
      import(
        "./features/socialmedia-templates/socialmedia-templates.module"
      ).then((m) => m.SocialmediaTemplatesModule),
  },
  {
    path: "myorders",
    loadChildren: () =>
      import("./features/my-orders/my-orders.module").then(
        (m) => m.MyOrdersModule
      ),
  },
  {
    path: "quotations",
    loadChildren: () =>
      import("./features/quotations/quotations.module").then(
        (m) => m.QuotationsModule
      ),
  },
  {
    path: "mywishlist",
    loadChildren: () =>
      import("./features/my-wishlist/my-wishlist.module").then(
        (m) => m.MyWishlistModule
      ),
  },
  {
    path: "myaddresses",
    loadChildren: () =>
      import("./features/my-addresses/my-addresses.module").then(
        (m) => m.MyAddressesModule
      ),
  },
  {
    path: "guides",
    loadChildren: () =>
      import("./features/guides/guides.module").then((m) => m.GuidesModule),
  },
  {
    path: "business-list",
    loadChildren: () =>
      import("./features/user-landing/user-landing.module").then(
        (m) => m.UserLandingModule
      ),
  },
  {
    path: "profile",
    component: UserProfileComponent,
  },
  {
    path: "qr",
    component: CheckUrlComponent,
  },
  {
    path: "offer-qr",
    component: CheckUrlComponent,
  },
  {
    path: "notifications",
    loadChildren: () =>
      import("./features/notifications/notifications.module").then(
        (m) => m.NotificationsModule
      ),
  },
  {
    path: "offer",
    loadChildren: () =>
      import("./features/product-offer/product-offer.module").then(
        (m) => m.ProductOfferModule
      ),
  },
  {
    path: "signin",
    component: SigninComponent,
  },
  {
    path: "signup",
    component: SignupComponent,
  },
  {
    path: "payment",
    loadChildren: () =>
      import("./features/payments/payments.module").then(
        (m) => m.PaymentsModule
      ),
  },
  {
    path: "privacy-policy",
    loadChildren: () =>
      import("./features/privacy-policy/privacy-policy.module").then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: "live-shopping",
    loadChildren: () =>
      import("./features/slot-booking/slot-booking.module").then(
        (m) => m.SlotBookingModule
      ),
  },
  {
    path: "liveshop",
    loadChildren: () =>
      import("./features/liveshop/liveshop.module").then(
        (m) => m.LiveShopModule
      ),
  },
  {
    path: "maps",
    component: MapsComponent,
  },
  {
    path: "verification",
    component: VerificationComponent,
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "",
    loadChildren: () =>
      import("./features/home-feature/home-feature.module").then(
        (m) => m.HomeFeatureModule
      ),
  },
  {
    path: "homePage",
    loadChildren: () =>
      import("./features/homepage/homepage.module").then(
        (m) => m.HomepageModule
      ),
  },
  {
    path: "getsummary",
    loadChildren: () =>
      import("./features/homepage/homepage.module").then(
        (m) => m.HomepageModule
      ),
  },
  {
    path: "user-homePage",
    loadChildren: () =>
      import("./features//user-home/user-home.module").then(
        (m) => m.UserHomeModule
      ),
  },
  {
    path: "bulkupload",
    loadChildren: () =>
      import("valuchaincommon/bulk-upload/bulk-upload.module").then(
        (m) => m.BulkUploadModule
      ),
  },
  {
    path: "3Dmodel",
    loadChildren: () =>
      import("./features/ar-model/ar-model.module").then(
        (m) => m.ArModelModule
      ),
  },

  {
    path: "target/:id",
    loadChildren: () =>
      import("./features/promolink-landing/promolink-landing.module").then(
        (m) => m.PromolinkLandingModule
      ),
  },
  {
    path: "orderLinkCode",
    loadChildren: () =>
      import("./features/promolink-landing/promolink-landing.module").then(
        (m) => m.PromolinkLandingModule
      ),
  },
  {
    path: "urlCode",
    loadChildren: () =>
      import("./features/promolink-landing/promolink-landing.module").then(
        (m) => m.PromolinkLandingModule
      ),
  },
  {
    path: "promolink",
    loadChildren: () =>
      import("./features/promolink-landing/promolink-landing.module").then(
        (m) => m.PromolinkLandingModule
      ),
  },
  {
    path: "user",
    loadChildren: () =>
      import("./features/user/user.module").then((m) => m.UserModule),
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./features/auth-feature/auth-feature.module").then(
        (m) => m.AuthFeatureModule
      ),
  },
  { path: "**", redirectTo: "homePage" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: AppCustomPreloader,
      enableTracing: true,
      relativeLinkResolution: "legacy",
    }),
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
  providers: [CanDeactivateGaurdService],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.errorHandler = (error: any) => {
      console.error(error);
    };
  }
}
